/**
 * Production-safe logger utility
 * Prevents console logs from appearing in production builds
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isDebugMode = localStorage.getItem('debug') === 'true';

const logger = {
  log: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    // Always log errors, but in production send to error tracking service
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, you could send to Sentry or another error tracking service
      console.error(...args);
      // Example: Sentry.captureException(args[0]);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.debug(...args);
    }
  },
  
  table: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.table(...args);
    }
  },
  
  time: (label) => {
    if (isDevelopment || isDebugMode) {
      console.time(label);
    }
  },
  
  timeEnd: (label) => {
    if (isDevelopment || isDebugMode) {
      console.timeEnd(label);
    }
  },
  
  group: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.group(...args);
    }
  },
  
  groupEnd: () => {
    if (isDevelopment || isDebugMode) {
      console.groupEnd();
    }
  },
  
  // Helper to enable debug mode
  enableDebug: () => {
    localStorage.setItem('debug', 'true');
    logger.log('🐛 Debug mode enabled');
  },
  
  // Helper to disable debug mode
  disableDebug: () => {
    localStorage.removeItem('debug');
    logger.log('🚫 Debug mode disabled');
  }
};

// Make logger available globally in development
if (isDevelopment) {
  window.logger = logger;
}

export default logger;